/**
 * 枚举类：支付方式
 */
module.exports = {
    BALANCE: {
        name: '余额支付',
        value: 10
    },
    WECHAT: {
        name: '微信支付',
        value: 20
    },
    CARD: {
        name: '信用卡支付',
        value: 30
    },
    CASH: {
        name: '送货上门 (现金支付)',
        value: 40
    },
};
